enum Constants {
    AUTHENTICATED_USER = "HOLLYWOOD_SNAPBOX_AUTHENTICATED_USER",
    CORE_MODULE_URL = "https://api.a-ztek225.com/"

}

export default Constants